import { useQuery } from '@tanstack/react-query';
import api from '../services';

export const useCurrentCapAmount = (entityId, isOfferAction = false, enabled = true) => {
  const endpoint = isOfferAction
    ? `offer-action/current-cap-amount/daily/${entityId}`
    : `offers/current-cap-amount/${entityId}`;
  return useQuery({
    queryKey: ['currentCapAmount', entityId, isOfferAction],
    queryFn: async () => {
      const response = await api.get(endpoint);
      return response.data;
    },
    enabled: enabled && !!entityId,
  });
};